import React from "react";
import './Recognizing.scss';

const CaseComponent = ({ data }) => {
  const { title, description, img } = data;
  return (
    <div className="recognizing-case">
      <div className="title-container">
        <div className="img-container">
          <img src={img} alt="web development icon" />
        </div>
        <h3 className="title">{title}</h3>
      </div>
      <div className="description">{description}</div>
    </div>
  );
};
export default function Recognizing({ data }) {
  const { title, cases } = data;
  return (
    <section className="recognizing-wrapper">
      <div className="recognizing-text">
        <h2 className="recognizing-title">{title}</h2>
      </div>
      <div className="recognizing-cases">
        {cases.map((caseData) => <CaseComponent data={caseData} />)}
      </div>
    </section>
  );
}